import {
  Calendar,
  FileText,
  Gamepad2,
  Home,
  Image,
  LineChart,
  UserPlus,
  Users,
  UsersRound,
} from 'lucide-react';

const navigationItems = [
  { path: '/', icon: Home, labelKey: 'nav.home' },
  { path: '/analytics', icon: LineChart, labelKey: 'nav.analytics' },
  { path: '/sessions', icon: Calendar, labelKey: 'nav.sessions' },
  { path: '/templates', icon: FileText, labelKey: 'nav.templates' },
  { path: '/players', icon: Users, labelKey: 'nav.players' },
  { path: '/player-groups', icon: UserPlus, labelKey: 'nav.groups' },
  { path: '/team-presets', icon: UsersRound, labelKey: 'nav.teams' },
  { path: '/games', icon: Gamepad2, labelKey: 'nav.games' },
  { path: '/images', icon: Image, labelKey: 'nav.images' },
] as const;

export { navigationItems };
